// Vite entry — wraps <App/> in QueryClientProvider + ThemeProvider + CssBaseline
// + BrowserRouter. R35: no <SupabaseProvider> — admin uses singleton from
// @/lib/supabase directly.

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { theme } from "@/theme";
import { queryClient } from "@/lib/queryClient";
import { App } from "@/App";

// Touch ENV at startup so the fail-loud wrapper throws synchronously if any
// required env var is missing (R41).
import "@/lib/env";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
